export enum PromotionalContentPlacement {
  Top = 'top',
  Bottom = 'bottom',
  MobileBanner = 'Mobile Banner',
  Sidebar = 'Sidebar',
  MidContent = 'Mid-Content',
}
